import { render, staticRenderFns } from "./CostProfitCenter.vue?vue&type=template&id=134dfd72&scoped=true&"
import script from "./CostProfitCenter.vue?vue&type=script&lang=js&"
export * from "./CostProfitCenter.vue?vue&type=script&lang=js&"
import style0 from "./CostProfitCenter.vue?vue&type=style&index=0&id=134dfd72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134dfd72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
